import { makeStyles } from '@material-ui/styles'

export default makeStyles((_theme) => ({
  dropShipForm: {
    marginBottom: '20px',
  },
  dropShipLabel: {
    marginBottom: '10px',
    fontSize: '12px',
  },
  radioGroup: {
    flexWrap: 'nowrap',
    height: '35px',
  },
  radio: {
    border: '1px solid #E5E5E5',
    margin: '0',
    overflow: 'hidden',
    width: '100px',
    '&:first-of-type': {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
    '&:last-of-type': {
      borderLeft: 'none',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
    },
    '& .MuiRadio-root': {
      padding: '9px 6px 9px',
    },
    '&.Mui-disabled': {
      // Border color matches the old palette from the standalone cart app
      // and should be unified in later refactors.
      borderColor: 'rgba(0, 0, 0, 0.26)',
    },
    '& .MuiRadio-colorSecondary': {
      backgroundColor: 'transparent',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '0.75rem',
      fontWeight: '500',
    },
    '&.selected': {
      backgroundColor: '#F5F6F8',
      '& .MuiRadio-colorSecondary.Mui-checked:hover': {
        backgroundColor: '#F5F6F8',
      },
    },
    '& .MuiSvgIcon-root': {
      height: '17px',
      width: '17px',
    },
    '@media(min-width: 375px)': {
      width: '119px',
    },
  },
}))
